// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=OkResponseWrappingCompanyTypeList|schemaHash=90b4c98b837254da67ba3b4d987b613a2a627ae5

import { setDefinedValue } from '@myre/common-primitives';

import { parseCompanyTypeFromJSON, parseCompanyTypeToJSON } from './CompanyType';
import { parseResponseMetaFromJSON, parseResponseMetaToJSON } from './ResponseMeta';

export function parseOkResponseWrappingCompanyTypeListFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaFromJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseCompanyTypeFromJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseOkResponseWrappingCompanyTypeListToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaToJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseCompanyTypeToJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}
